export const actionSaveMap = {
  create: 1,
  updateData: 2,
  updateLayout: 3,
  publish: 4,
};
